import { memo } from 'react';
import { AgentBubbleProps } from '../ChatBubble.types';
import { AgentResponseSkeleton } from './AgentResponseSkeleton';
import { AgentHeader } from './AgentHeader';
import { getChatStores } from '@/features/chats/lib/chat-store-bindings';
import { motion } from 'motion/react';
import { ChatWidgetVersions } from '../../ChatWidgetVersions';
import { useMessageAgent } from '../../../model/useMessageAgent';
import { CHAT_REPLY_MARKER } from '@/shared/lib/chat-layout';
import { getChatInlineWidgets } from '@/lib/chat-inline-widgets';

export const AgentResponse = memo(
  ({ children, agentId, messageId, hasWidget = false }: AgentBubbleProps) => {
    const { agent, isLoading } = useMessageAgent(agentId);
    const { widgetStore } = getChatStores();
    const { hasWidgetForMessage } = widgetStore.useWidgetStore();
    const { InlineWidgets } = getChatInlineWidgets();

    // Check if this message has widgets
    const messageHasWidget = messageId ? hasWidgetForMessage(messageId) : false;

    return (
      <motion.div
        className="w-full mt-3 mr-8"
        data-testid="agent-response"
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: -10 }}
        transition={{ duration: 0.2, ease: 'easeOut' }}
      >
        {!agent || isLoading ? (
          <AgentResponseSkeleton />
        ) : (
          <>
            <AgentHeader agent={agent} />
            <div {...CHAT_REPLY_MARKER} className="prose prose-sm max-w-none text-foreground">
              {children}
            </div>
            {messageId && <InlineWidgets messageId={messageId} />}

            {/* Render widget toggles if this message has widgets */}
            {(hasWidget || messageHasWidget) && messageId && agentId && (
              <div className="flex flex-wrap gap-2 mt-3">
                <ChatWidgetVersions agentId={agentId} messageId={messageId} />
              </div>
            )}
          </>
        )}
      </motion.div>
    );
  },
);
AgentResponse.displayName = 'AgentResponse';
